import { useQuery } from "react-query";
import { useIntl } from "react-intl";

import {
  AdminListRequestOfBaseFilter,
  EvaluationType,
  ListResponseOfEvaluationType,
  BaseFilter,
} from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";

type SelectEvaluationTypeProps = {
  parentOnChange?: (v?: string) => void;
} & Omit<
  AutocompleteWithQueryProps<EvaluationType>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectEvaluationType = ({
  parentOnChange,
  onChange,
  ...rest
}: SelectEvaluationTypeProps) => {
  const { formatMessage: t } = useIntl();
  const { evaluationService } = useGlobalContext();

  const fetchedEvaluationTypes = useQuery<ListResponseOfEvaluationType>(
    [
      "evaluationTypes"
    ],
    () =>
      evaluationService.getEvaluationTypes(
        AdminListRequestOfBaseFilter.fromJS({
          parameters: BaseFilter.fromJS({}),
          sortField: "name",
        })
      )
  );

  const handleOnChange = (v?: string) => {
    if (parentOnChange) parentOnChange(v);

    onChange(v);
  };

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="name"
      fetchedData={fetchedEvaluationTypes}
      failMessage={t({ id: "selectEvaluationTypeFetchFailed" })}
      onChange={handleOnChange}
    />
  );
};

export default SelectEvaluationType;
